/*
  This method transforms the current transfer (in the uploader) in to a transfers.list compatible model
*/
export const transformNewTransferToTransferListItem = (currentTransfer) => {
  const expiryInSeconds = currentTransfer.expiryInSeconds;

  const transferDate = new Date();

  return {
    id: currentTransfer.id,
    parent_id: currentTransfer.parent_id,
    state: currentTransfer.state,
    shortened_url: currentTransfer.shortURL,
    expiresAt: new Date(
      transferDate.getTime() + expiryInSeconds * 1000
    ).toISOString(),
    password_protected: currentTransfer.password !== null,
    uploaded_at: transferDate.toISOString(),
    expiryInSeconds,
    size: (currentTransfer.items || []).reduce(
      (size, item) => (size += item.size),
      0
    ),
    deleted_at: null,
    account_id: currentTransfer.accountId,
    security_hash: currentTransfer.securityHash,
    number_of_downloads: 0,
    display_name: currentTransfer.title,
    items: (currentTransfer.items || currentTransfer.files || []).map(
      (item) => ({
        ...item,
        id: item.file.ref.id,
        file: {
          ...item.file,
          ref: {
            ...item.file.ref,
            id: item.file.ref.id,
            name: item.file.ref.name,
            retries: 0,
            size: item.file.ref.size,
            item_type: item.file.ref.apiType,
            chunk_size: item.file.ref.chunkSize,
            apiType: item.file.ref.apiType,
          },
        },
      })
    ),
    files: (currentTransfer.files || currentTransfer.items || []).map(
      (file) => ({
        id: file.id,
        name: file.name,
        retries: 0,
        size: file.size,
        item_type: file.apiType,
        chunk_size: file.chunkSize,
        apiType: file.apiType,
      })
    ),
    itemsTree: currentTransfer.itemsTree,
    recipients: (currentTransfer.recipients || []).map((email) => ({
      email,
      transfer_downloaded: false,
      bounced: false,
    })),
  };
};
